import { render, staticRenderFns } from "./SaleSlips.vue?vue&type=template&id=43bc8f04&"
import script from "./SaleSlips.vue?vue&type=script&lang=js&"
export * from "./SaleSlips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports